/* eslint-disable no-unused-vars */
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PackageTable({ packages }) {
  const navigate = useNavigate();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {[
              'ID',
              'Direction Type',
              'Company',
              'Tracking Number',
              'Created At',
              'Action'
            ].map((header) => (
              <TableCell
                key={header}
                sx={{ fontWeight: 'bold', fontSize: '1rem' }}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {packages.length > 0 ? (
            packages.map((pkg) => (
              <TableRow key={pkg.id}>
                <TableCell>{pkg.id}</TableCell>
                <TableCell>{pkg.direction_type}</TableCell>
                <TableCell>{pkg.company_name}</TableCell>
                <TableCell>{pkg.tracking_number}</TableCell>
                <TableCell>
                  {new Date(pkg.createdAt).toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true
                  })}
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(`/package-details/${pkg.id}`)}
                  >
                    Go to Package Details
                  </Button>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No packages found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
